module.exports = __webpack_public_path__ + "public/SiteImages/medium_no_image.png?fc77a798";